module.exports = __webpack_public_path__ + "static/media/modelC2.6817fda4.gif";